import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../../src/context/authFirebase';
import { collectionGroup, getDocs, query, where, orderBy } from "firebase/firestore";
import { motion } from 'framer-motion';

const PostCard = ({ post, linkBase }) => (
  <div className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
    <div className="relative overflow-hidden">
      <img
        className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
        src={post.file}
        alt={post.title}
      />
    </div>
    <div className="p-6 flex flex-col gap-3">
      <Link to={`/${linkBase}/${post.id}`}>
        <h3 className="text-sm font-bold text-blueblack hover:text-seablue transition-colors leading-snug">
          {post.title}
        </h3>
      </Link>
      <div
        dangerouslySetInnerHTML={{ __html: post.body }}
        className="text-gray-500 text-xs line-clamp-3 leading-relaxed"
      />
      <div className="flex items-center justify-between mt-1">
        <Link to={`/${linkBase}/${post.id}`}>
          <button className="px-4 py-2 bg-blueblack text-white text-xs font-semibold rounded-full hover:bg-seablue transition-all duration-300">
            Read More
          </button>
        </Link>
        {post.date && <p className="text-xs text-gray-400 font-medium">{post.date}</p>}
      </div>
    </div>
  </div>
);

export default function NewsEvents() {
  const [news, setNews]     = useState([]);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const newsQuery   = query(collectionGroup(db, "Post"), where("category", "==", "news"),   orderBy("timeStamp", "desc"));
      const eventsQuery = query(collectionGroup(db, "Post"), where("category", "==", "events"), orderBy("timeStamp", "desc"));
      try {
        const [newsSnap, eventsSnap] = await Promise.all([getDocs(newsQuery), getDocs(eventsQuery)]);
        setNews(newsSnap.docs.map(doc => ({ ...doc.data(), id: doc.id })));
        setEvents(eventsSnap.docs.map(doc => ({ ...doc.data(), id: doc.id })));
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    document.title = "EIT Ghana Limited - News & Events";
  }, []);

  return (
    <motion.div
      className="pt-16 bg-gray-50 min-h-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >

      {/* ── BANNER CARD ── */}
      <section className="pt-8 pb-0">
        <div className="max-w-7xl mx-auto px-5 lg:px-20">
          <motion.div
            className="bg-blueblack rounded-3xl p-10 lg:p-16 relative overflow-hidden"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.6 }}
          >
            <div className="absolute -top-16 -right-16 w-56 h-56 bg-yellowcolor/10 rounded-full" />
            <div className="absolute -bottom-10 right-32 w-36 h-36 bg-seablue/20 rounded-full" />
            <div className="relative z-10 max-w-xl">
              <p className="text-yellowcolor font-semibold text-xs uppercase tracking-widest mb-4">Stay Updated</p>
              <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4">News & Events</h1>
              <p className="text-gray-300 text-lg leading-relaxed">
                Stay informed with the latest news and upcoming events from EIT Ghana Limited.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── NEWS ── */}
      <section className="py-8">
        <div className="max-w-7xl mx-auto px-5 lg:px-20">

          <div className="mb-8">
            <p className="text-seablue font-semibold text-xs uppercase tracking-widest mb-2">Latest</p>
            <h2 className="text-3xl font-bold text-blueblack">News</h2>
          </div>

          {news.length > 0 ? (
            <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-5">
              {news.map(post => <PostCard key={post.id} post={post} linkBase="news" />)}
            </div>
          ) : (
            <div className="bg-white rounded-3xl p-12 shadow-sm text-center">
              <p className="text-blueblack font-semibold">There are no current news available.</p>
            </div>
          )}
        </div>
      </section>

      {/* ── EVENTS ── */}
      <section className="py-8 pb-16">
        <div className="max-w-7xl mx-auto px-5 lg:px-20">

          <div className="mb-8">
            <p className="text-seablue font-semibold text-xs uppercase tracking-widest mb-2">Upcoming</p>
            <h2 className="text-3xl font-bold text-blueblack">Events</h2>
          </div>

          {events.length > 0 ? (
            <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-5">
              {events.map(post => <PostCard key={post.id} post={post} linkBase="events" />)}
            </div>
          ) : (
            <div className="bg-white rounded-3xl p-12 shadow-sm text-center">
              <p className="text-blueblack font-semibold">There are no current events available.</p>
            </div>
          )}

        </div>
      </section>

    </motion.div>
  );
}
